import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import {
    Button,
    Box,
    Typography,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Select,
    FormControl,
    InputLabel,
    Divider
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

const KnowledgeBase = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("all");
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedItem(null);
    };

    const [kbItems, setKbItems] = useState([
        {
            id: 1,
            title: "Create Your Store",
            subtitle: "A Step-by-Step Guide",
            category: "Vendor Onboarding",
            views: 1250,
            likes: 45,
            time: "2 min read",
            type: "article",
            isVisible: true
        },
        {
            id: 2,
            title: "How to Add Your First Product",
            subtitle: "Inventory Management",
            category: "Vendor Onboarding",
            views: 3400,
            likes: 120,
            time: "5 min read",
            type: "article",
            isVisible: true
        },
        {
            id: 3,
            title: "Bouteek Vendor Dashboard Overview",
            subtitle: "Getting Started",
            category: "User Onboarding",
            views: 890,
            likes: 32,
            time: "10 min read",
            type: "article",
            isVisible: true
        },
        {
            id: 4,
            title: "Understanding Marketplace Rules",
            subtitle: "Policies & Terms",
            category: "General",
            views: 2100,
            likes: 18,
            time: "4 min read",
            type: "article",
            isVisible: true
        },
        {
            id: 5,
            title: "Managing Customer Returns",
            subtitle: "Policies & Procedures",
            category: "Vendor Onboarding",
            views: 560,
            likes: 12,
            time: "3 min read",
            type: "article",
            isVisible: false
        },
        {
            id: 6,
            title: "AI Growth Insights Explained",
            subtitle: "Advanced Features",
            category: "AI Tools",
            views: 4500,
            likes: 210,
            time: "15 min read",
            type: "article",
            isVisible: true
        },
    ]);

    const filteredItems = kbItems.filter(item => {
        const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.category.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesCategory = categoryFilter === "all" || item.category === categoryFilter;
        return matchesSearch && matchesCategory;
    });

    return (
        <>
            <div className="main_title">
                <h1>Knowledge Base Management</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button>-<button onClick={() => navigate("/admin-support")}> Admin Support </button>-Knowledge Base
                </p>
            </div>

            <div className="stats_boxes gap_m mb_20">
                <div className="cards">
                    <div className="data_top">
                        <h2>124 <p>Total Articles</p></h2>
                        <figure className="blue"><DescriptionOutlinedIcon fontSize="large" /></figure>
                    </div>
                </div>
                <div className="cards">
                    <div className="data_top">
                        <h2>245k <p>Total Views</p></h2>
                        <figure className="sucess"><VisibilityOutlinedIcon fontSize="large" /></figure>
                    </div>
                </div>
                <div className="cards">
                    <div className="data_top">
                        <h2>12.5k <p>Total Likes</p></h2>
                        <figure className="danger"><ThumbUpOutlinedIcon fontSize="large" /></figure>
                    </div>
                </div>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search content..."
                        />
                        <div className="form ml_10">
                            <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
                                <option value="all">Categories</option>
                                <option value="User Onboarding">User Onboarding</option>
                                <option value="Vendor Onboarding">Vendor Onboarding</option>
                                <option value="AI Tools">AI Tools</option>
                                <option value="General">General</option>
                            </select>
                        </div>
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => navigate("add")}><AddIcon /> Create New Content</Button>
                    </div>
                </div>

                <div className="help-center-grid mt_20">
                    {filteredItems.map((item, i) => (
                        <div className={`help-card ${!item.isVisible ? 'hidden_item' : ''}`} key={i}>
                            <div className="help-icon-wrapper">
                                <div className="help-icon">
                                    <DescriptionOutlinedIcon />
                                </div>
                                <div className="card_actions_overlay">
                                    <IconButton size="small" onClick={(e) => handleMenuOpen(e, item)}>
                                        <MoreVertIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>

                            <div className="help-content">
                                <div className="d_flex justify-between align-center mb_5">
                                    <Chip label={item.category} size="small" sx={{ fontSize: '10px', height: '20px', background: '#f1f5f9' }} />
                                    {!item.isVisible && <Chip label="Hidden" size="small" variant="outlined" color="warning" sx={{ fontSize: '10px', height: '20px' }} />}
                                </div>
                                <h4>{item.title}</h4>
                                {item.subtitle && <p className="sub">{item.subtitle}</p>}

                                <div className="card_footer_meta">
                                    <span className="meta_item"><VisibilityOutlinedIcon sx={{ fontSize: 14 }} /> {item.views.toLocaleString()}</span>
                                    <span className="meta_item"><ThumbUpOutlinedIcon sx={{ fontSize: 14 }} /> {item.likes}</span>
                                    <span className="time">{item.time}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleMenuClose}>
                    <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Edit Content</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                    <ListItemIcon>
                        {selectedItem?.isVisible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                    </ListItemIcon>
                    <ListItemText>{selectedItem?.isVisible ? 'Hide from Public' : 'Make Public'}</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleMenuClose} sx={{ color: '#d32f2f' }}>
                    <ListItemIcon><DeleteOutlineIcon fontSize="small" sx={{ color: '#d32f2f' }} /></ListItemIcon>
                    <ListItemText>Remove</ListItemText>
                </MenuItem>
            </Menu>

        </>
    );
}
export default KnowledgeBase;